export default [
  {
    path: '/fasah-certificate',
    name: 'fasah-certificate',
    component: () => import('@/views/fasah-certificate/FasahCertificate.vue'),
    meta: {
      title: 'Fasah Certificate ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Fasah Certificate',
      pageTitle: 'Fasah Certificate',
      breadcrumb: [
        {
          text: 'Fasah Certificate',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  //   {
  //     path: "/facility/:id",
  //     name: "show-facility",
  //     component: () =>
  //       import("@/views/Facility/control-facility/ShowFacility.vue"),
  //     meta: {
  //       title: "Facility Info",
  //       requiresAuth: true,
  //       action: "browes",
  //       resource: "Facility Info",
  //       pageTitle: "Facility Info",
  //       breadcrumb: [
  //         {
  //           text: "Facility Info"
  //         },
  //         {
  //           text: "List",
  //           active: true
  //         }
  //       ]
  //     }
  //   }
]
